import trainTime from '../lib/TrainTime';
import RewardPointsService from '../services/RewardPointsService';
import OrderService from '../services/OrderService';
import SmartcardStore from '../stores/SmartcardStore';
import { SmartcardErrorBlocking } from '../constants/AppConstants';


const RewardPointsActions = {
    async registerTicketsForRewardPoints(order) {
        try {
            const { customerId, email, id } = order;
            const purchaseDate = trainTime().format('YYYY-MM-DD');

            const { trips } = order;

            let allTickets = [];

            trips.map(trip => {
                const tickets = trip.getTicketsWithTicketTypeAndValidity();
                allTickets.push(tickets.toJS());
            });

            const tickets = allTickets.flat().map(ticket => {
                return {
                    ticketId: ticket.id,
                    travelStartDate: trainTime.isoDate(ticket.travelStartDate),
                    ticketType: ticket.ticketType,
                    ticketCost: ticket.price,
                    setter: '',
                };
            });

            const smartcard = SmartcardStore.getCurrent();

            const deliveryOptions = await OrderService.getDeliveryOptions(order.id, smartcard);

            const eTicketOption = deliveryOptions.find(option => option.isETicket());
            const smartcardOption = deliveryOptions.find(option => option.isSmartcard());

            const smartcardErrors = smartcardOption && smartcardOption.errors;

            let canChooseSmartcard = !!smartcardOption;

            /*
                If there are any 'blocking' errors that make Smartcard
                unavailable as a fulfilment option, we will give reward
                points for eligible fares when 'non preferred' delivery
                methods are chosen.
            */
            if (smartcardErrors) {
                // convert errors and known error constants to same format for comparison
                const smartcardErrorBlockingStrings = Object.values(SmartcardErrorBlocking).map(x =>
                    x.toLowerCase(),
                );

                // convert errors and known error constants to same format for comparison
                const errorStrings = smartcardErrors
                    .map(err => {
                        return Object.keys(err).map(x => x.toLowerCase());
                    })
                    .flat();

                // check if fulfilment errors are 'blocking' errors
                errorStrings.map(errString => {
                    if (smartcardErrorBlockingStrings.includes(errString)) {
                        canChooseSmartcard = false;
                    }
                });
            }

            const hasPreferredDelivery = !!eTicketOption || canChooseSmartcard;

            await RewardPointsService.registerTicketsForReward(
                id,
                purchaseDate,
                hasPreferredDelivery,
                tickets,
                customerId,
                email,
            );
        } catch (e) {
            console.warn('error registering tickets for reward points', e);
        }
    },
};

export default RewardPointsActions;



// WEBPACK FOOTER //
// ./src/actions/RewardPointsActions.js